import { render, staticRenderFns } from "./HeadTips.vue?vue&type=template&id=0966c2b4&scoped=true"
import script from "./HeadTips.vue?vue&type=script&lang=js"
export * from "./HeadTips.vue?vue&type=script&lang=js"
import style0 from "./HeadTips.vue?vue&type=style&index=0&id=0966c2b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0966c2b4",
  null
  
)

export default component.exports